import React from 'react';

import {
  getDeclinationCopyByStatus,
  resolveDeclinationStatus
} from '../DeclinationReasonsDrawer/DeclinationReasons.shared';
import { DeclinationReasonsDrawerBase } from '../DeclinationReasonsDrawer/DeclinationReasonsDrawerBase';

export const SendoutDeclinationReasonsDrawer = ({
  initialValues,
  isSubmitting = false,
  onClose = () => {},
  onSaved = () => {},
  status
}) => {
  const declinationStatus = resolveDeclinationStatus(status?.id);

  if (!declinationStatus) return null;

  const { title, reasons } = getDeclinationCopyByStatus(declinationStatus);

  return (
    <DeclinationReasonsDrawerBase
      initialValues={initialValues}
      isSubmitting={isSubmitting}
      onClose={onClose}
      onSaved={onSaved}
      reasons={reasons}
      statusId={status?.id}
      title={title}
    />
  );
};
